import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import PageError from '@/contexts/Erros/PageError';
import { routes } from './routes';
import { WithAxios } from '../services/WithAxios';

const routesWithRoles = routes();

const router = createBrowserRouter([
    {
        element: <WithAxios />,
        errorElement: <PageError />,
        children: [...routesWithRoles],
    },
]);

export default function Routes(): React.ReactElement {
    return (
        <React.Suspense fallback={null}>
            <RouterProvider router={router} />
        </React.Suspense>
    );
}
